import { buildObjectIdFilter } from './algolia-filters'

export const fetchCoachActivityHit = async (
  searchClient,
  indexName,
  objectId,
) => {
  if (!objectId) {
    return null
  }

  const { results } = await searchClient.search([
    {
      indexName,
      params: {
        filters: buildObjectIdFilter(objectId),
        hitsPerPage: 1,
      },
    },
  ])

  return results[0]?.hits?.[0] || null
}
